import Joi from 'joi'

const ifCondition = Joi.object().keys({
  condition: Joi.string().required().label('IF Condition'),
  value: Joi.alternatives(Joi.string(), Joi.array(), Joi.number()).label('Condition Value').required(),
})

const thenCondition = Joi.object().keys({
  then: Joi.string().label('THEN Condition'),
  action: Joi.string().required(),
  thenData: Joi.alternatives(Joi.string(), Joi.array(), Joi.number()).required(),
})

export const ruleSchema = Joi.object({
  rule: {
    name: Joi.string().max(30).trim().required().label('Rule Name').messages({
      'string.empty': `Name cannot be an empty field`,
      'any.required': `Name is a required field`,
      'string.max': `Name length must be less than or equal to 30 characters`,
    }),
    entity: Joi.string().required().label('When').messages({
      'string.base': `When must be Specified`,
      'string.empty': 'When must be Specified',
    }),
    trigger: Joi.string().required().messages({
      'string.base': `Trigger must be Specified`,
      'string.empty': 'Trigger must be Specified',
    }),
  },
  ifConditionList: Joi.array().items(ifCondition).required().messages({
    'string.base': `If Condition must be specified`,
  }),
  thenConditionList: Joi.array().items(thenCondition).required().messages({
    'string.base': `Then Condition must be specified`,
  }),
})
